const ADMIN       = 'admin'
const OPERATOR    = 'operator'
const VIEWER  = 'viewer'
const USER        = 'user'
const RESELLER    = 'reseller'

module.exports = {
    ADMIN,
    OPERATOR,
    VIEWER,
    USER,
    RESELLER
}